import { getGroupsStore } from '../GroupsStore';
import { mutatorAction } from 'satcheljs';

export const groupMembershipStoreUpdate = mutatorAction(
    'groupMembershipStoreUpdate',
    (groupId: string, isMember: boolean) => {
        let groupsStore = getGroupsStore();
        let group = groupId && groupsStore.groups.get(groupId.toLowerCase());
        if (group?.groupDetails) {
            group.groupDetails.UserGroupRelationship.IsMember = isMember;
        }
    }
);
